import { savePageview, reportPageView as apiReportPageView } from '../api/footApi';

let cachedIPInfo = null;

const provinceMap = {
  'Hebei': '河北省', 'Nei Mongol': '内蒙古自治区', 'Liaoning': '辽宁省', 'Jilin': '吉林省',
  'Heilongjiang': '黑龙江省', 'Shanghai': '上海市', 'Jiangsu': '江苏省', 'Zhejiang': '浙江省',
  'Anhui': '安徽省', 'Fujian': '福建省', 'Jiangxi': '江西省', 'Shandong': '山东省',
  'Henan': '河南省', 'Hubei': '湖北省', 'Hunan': '湖南省', 'Guangdong': '广东省',
  'Guangxi': '广西壮族自治区', 'Hainan': '海南省', 'Chongqing': '重庆市', 'Sichuan': '四川省',
  'Guizhou': '贵州省', 'Yunnan': '云南省', 'Tibet': '西藏自治区', 'Shaanxi': '陕西省',
  'Gansu': '甘肃省', 'Qinghai': '青海省', 'Ningxia': '宁夏回族自治区', 'Xinjiang': '新疆维吾尔自治区',
  'Beijing': '北京市', 'Tianjin': '天津市', 'Hong Kong': '香港特别行政区', 'Macao': '澳门特别行政区',
  'Taiwan': '台湾省'
};

const cityMap = {
  'Shijiazhuang': '石家庄市', 'Beijing': '北京市', 'Shanghai': '上海市', 'Guangzhou': '广州市',
  'Shenzhen': '深圳市', 'Tianjin': '天津市', 'Chongqing': '重庆市', 'Chengdu': '成都市',
  'Hangzhou': '杭州市', 'Wuhan': '武汉市', 'Nanjing': '南京市', 'Xi\'an': '西安市',
  'Zhengzhou': '郑州市', 'Changsha': '长沙市', 'Shenyang': '沈阳市', 'Qingdao': '青岛市',
  'Suzhou': '苏州市', 'Harbin': '哈尔滨市', 'Dongguan': '东莞市', 'Foshan': '佛山市',
  'Wuxi': '无锡市', 'Changzhou': '常州市', 'Ningbo': '宁波市', 'Xiamen': '厦门市',
  'Jinan': '济南市', 'Zhongshan': '中山市', 'Huizhou': '惠州市', 'Wenzhou': '温州市',
  'Shantou': '汕头市', 'Zhuhai': '珠海市', 'Tangshan': '唐山市', 'Jiaxing': '嘉兴市'
};

function translateChinese(str) {
  if (!str || str === '未知' || str === 'N/A' || str === '-') return '未知';

  const province = provinceMap[str];
  if (province) return province;

  const city = cityMap[str];
  if (city) return city;

  if (/[\u4e00-\u9fa5]/.test(str)) {
    return str;
  }

  return str;
}

export async function getIPInfo() {
  if (cachedIPInfo) {
    return cachedIPInfo;
  }

  let ip = null;
  let province = '未知';
  let city = '未知';

  const geoApis = [
    () => new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'http://pv.sohu.com/cityjson?ie=utf-8';
      script.onload = () => {
        try {
          const data = window.returnCitySN;
          if (data && data.cip) {
            const cname = data.cname || '';
            const parts = cname.split(' ');
            resolve({
              ip: data.cip,
              province: translateChinese(parts[0]),
              city: translateChinese(parts[1] || parts[0])
            });
          } else {
            resolve(null);
          }
        } catch (e) {
          resolve(null);
        }
        if (script.parentNode) script.parentNode.removeChild(script);
      };
      script.onerror = () => {
        resolve(null);
        if (script.parentNode) script.parentNode.removeChild(script);
      };
      document.head.appendChild(script);
    }),
    () => fetch('https://api.ip.sb/geoip').then(res => res.json()).then(data => {
      if (data && data.ip) {
        return {
          ip: data.ip,
          province: translateChinese(data.region),
          city: translateChinese(data.city)
        };
      }
      return null;
    }).catch(() => null),
    () => fetch('https://api.ipify.org?format=json').then(res => res.json()).then(data => ({
      ip: data.ip,
      province: '未知',
      city: '未知'
    })).catch(() => null)
  ];

  for (const api of geoApis) {
    try {
      const result = await Promise.race([api(), new Promise(resolve => setTimeout(() => resolve(null), 8000))]);

      if (result && result.ip && result.ip !== '127.0.0.1' && result.ip !== '::1') {
        ip = result.ip;
        if (result.province && result.province !== '未知') {
          province = result.province;
        }
        if (result.city && result.city !== '未知') {
          city = result.city;
        }

        if (province !== '未知') {
          break;
        }
      }
    } catch (e) {
      console.debug('IP/地域解析失败:', e.message);
    }
  }

  if (!ip || ip === '127.0.0.1' || ip === '::1') {
    ip = '未知';
  }

  cachedIPInfo = { ip, province, city };
  return cachedIPInfo;
}

export async function reportPageView(pageName) {
  const ipInfo = await getIPInfo();

  const reportData = {
    ip: ipInfo.ip,
    province: ipInfo.province,
    city: ipInfo.city,
    pageName: pageName,
    timestamp: new Date().toISOString()
  };

  console.log('页面浏览记录:', reportData);

  try {
    await apiReportPageView(reportData);
    console.log('页面浏览记录上报成功');
  } catch (error) {
    console.debug('页面浏览记录上报失败:', error.message);
  }

  try {
    await savePageview();
    console.log('页面浏览量计数成功');
  } catch (error) {
    console.debug('页面浏览量计数失败:', error.message);
  }
}